import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface ConfirmButtonProps extends Omit<ButtonProps, "type"> {
  onClick?: () => void;
  isLoading?: boolean;
  hasChanges?: boolean;
  loadingText?: string | null;
  title?: string;
  type?: "primary" | "destructive";
}

export const ConfirmButton: React.FC<ConfirmButtonProps> = ({
  onClick,
  disabled,
  isLoading,
  hasChanges = true,
  className,
  children,
  loadingText,
  title = "Confirm",
  type = "primary",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={isLoading || disabled || !hasChanges}
      className={cn(
        "w-full sm:w-auto h-9 rounded-lg font-medium transition-colors",
        hasChanges && !disabled
          ? type === "destructive"
            ? "bg-rose-600 text-white hover:bg-rose-700"
            : "bg-indigo-600 text-white hover:bg-indigo-700"
          : "bg-neutral-100 text-neutral-500 hover:bg-neutral-200 cursor-not-allowed",
        className
      )}
      {...props}
    >
      {isLoading ? (
        <>
          <Loader2
            className={cn("h-3 w-3 animate-spin", loadingText && "mr-2")}
          />
          {loadingText}
        </>
      ) : (
        children || title
      )}
    </Button>
  );
};
